import { useCallback, useMemo } from "react";
import { useSiloWeb3 } from "../SiloWeb3Provider";
import { useTransactionMachine } from "./TransactionContext";
import { isTransactionPending, isTransactionRecent } from "./utilities";

export type WalletInfoState =
  | { _tag: "idle" }
  | { _tag: "pending"; count: number }
  | { _tag: "success" }
  | { _tag: "error"; message?: string };

const MAX_DISPLAYED_TRANSACTIONS = 8;

export const useWalletInfo = () => {
  const { state, send } = useTransactionMachine();
  const { transactions } = state.context;
  const { chainId } = useSiloWeb3();

  const recentTransactions = useMemo(() => {
    const sortedTransactions = transactions
      .filter((transaction) => transaction.chainId === chainId)
      .filter(isTransactionRecent)
      .sort((a, b) => b.timeAdded - a.timeAdded);

    return sortedTransactions.slice(0, MAX_DISPLAYED_TRANSACTIONS);
  }, [transactions, chainId]);

  const clearTransactions = useCallback(() => {
    send("CLEAR");
  }, [send]);

  const walletInfoState: WalletInfoState = useMemo(() => {
    switch (true) {
      case state.matches("default"):
      default:
        return { _tag: "idle" };
      case state.matches("pending"): {
        const count =
          state.context.transactions.filter(isTransactionPending).length;

        return { _tag: "pending", count };
      }
      case state.matches("success"):
        return { _tag: "success" };
      case state.matches("error"):
        return { _tag: "error" };
    }
  }, [state]);

  return {
    recentTransactions,
    clearTransactions,
    walletInfoState,
  };
};
